import React, { useEffect, useState } from "react";
import { useIntl } from "react-intl";
import { getPrivacyPolicy } from "../../../app/modules/Auth/_redux/authCrud";

function PrivacyPolicy(props) {
  const intl = useIntl();
  const [file, setFile] = useState("");
  const [loading, setLoading] = useState(true);
  const _getPrivacyPolicy = () => {
    getPrivacyPolicy()
      .then(({ data }) => {
        setFile(
          `data:${data.mimeType};base64,${data.fileData}#toolbar=0&navpanes=0&scrollbar=0`
        );
        console.log(data);
        setLoading(false);
      })
      .catch(err => {
        console.log(err, "error when getting terms of use");
      });
  };

  useEffect(_getPrivacyPolicy, []);
  return (
    <div className="bg-white w-100 h-100 card card-custom p-10">
      {!loading && (
        <>
          <h3 className="form-title text-center">
            {intl.formatMessage({ id: "PRIVACY_POLICY" })}
          </h3>
          <iframe
            title={intl.formatMessage({ id: "TERMS_OF_USE" })}
            src={file}
            className={"pdfiFrame"}
          />
        </>
      )}
    </div>
  );
}

export default PrivacyPolicy;
